import React, { FC } from "react";

import emptyStateImg from "@/assets/empty-state.svg";
import { Text } from "@/components/Text";
import { Flex } from "@/eworkitComponents";

export interface INoRecordsProps {}

export const NoRecords: FC<INoRecordsProps> = ({ children }) => {
  return (
    <Flex direction="column" align="center" justify="center" innerMargin="lg" padding={["lg", false]}>
      <Flex>
        <img src={emptyStateImg} width={128} height={128} />
      </Flex>

      <Text size="xl" weight="bold">
        {children}
      </Text>
    </Flex>
  );
};
